var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemQuestionMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 2c5.522 0 10 4.478 10 10s-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2m0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-8c1.898 0 3.3 1.377 3.3 3.292 0 1.477-.815 2.517-2.257 3.039l-.043.013v.156a1 1 0 0 1-.883.993L12 14.5a1 1 0 0 1-.993-.883L11 13.5v-.917a1 1 0 0 1 .805-.98c1.1-.22 1.495-.613 1.495-1.311C13.3 9.49 12.801 9 12 9c-.702 0-1.23.494-1.294 1.157l-.006.135a1 1 0 0 1-2 0A3.266 3.266 0 0 1 12 7"
})));
export default SvgGemQuestionMark;